import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  notification,
} from "antd";
import { CheckIcon, X } from "lucide-react";
import { MailOutlined } from "@ant-design/icons";
import { useCreateDemoRequestMutation } from "../../store/api/apiSlice";

const DemoForm = ({ isOpen, onClose }) => {
  const [form] = Form.useForm();
  const [createDemoRequest, { isLoading }] = useCreateDemoRequestMutation();

  const handleSubmit = async (values) => {
    try {
      await createDemoRequest(values).unwrap();

      notification.success({
        message: "Success",
        description:
          "Your demo request has been submitted successfully. We will contact you soon!",
      });

      form.resetFields();

      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {}
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
      className="space-y-6"
    >
      <Form.Item
        label={<span className="text-white text-sm">Full Name</span>}
        name="full_name"
        rules={[{ required: true, message: "Please enter your full name" }]}
      >
        <Input
          placeholder="Type here..."
          className="px-4 h-11 bg-white rounded-xl"
        />
      </Form.Item>

      <Form.Item
        label={<span className="text-white text-sm">Email Address</span>}
        name="email"
        rules={[
          { required: true, message: "Please enter your email" },
          { type: "email", message: "Please enter a valid email" },
        ]}
      >
        <Input
          prefix={<MailOutlined className="text-gray-400" />}
          placeholder="example@gmail.com"
          className="px-4 h-11 bg-white rounded-xl"
        />
      </Form.Item>

      <Form.Item
        label={<span className="text-white text-sm">Company Name</span>}
        name="company"
        rules={[{ required: true, message: "Please enter your company name" }]}
      >
        <Input
          placeholder="Type here..."
          className="px-4 h-11 bg-white rounded-xl"
        />
      </Form.Item>

      <Form.Item
        label={
          <span className="text-white text-sm">
            Do you have a survey in mind?
          </span>
        }
        name="survey_in_mind"
        initialValue="yes"
      >
        <Select className="h-11" dropdownStyle={{ borderRadius: "12px" }}>
          <Select.Option value="yes">
            Yes, I have a survey in mind.
          </Select.Option>
          <Select.Option value="no">
            No, I need help creating one.
          </Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label={<span className="text-white text-sm">Survey Start Date</span>}
        name="start_date"
        rules={[{ required: true, message: "Please select a start date" }]}
      >
        <DatePicker
          className="w-full px-4 h-11 bg-white rounded-xl"
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item className="mb-0">
        <Button
          type="primary"
          htmlType="submit"
          loading={isLoading}
          disabled={isLoading}
          className="w-full bg-blue hover:bg-[#ff4a1a] py-4 h-auto rounded-lg border-none"
        >
          <div className="flex items-center justify-center gap-2">
            Submit Request
            <CheckIcon />
          </div>
        </Button>
      </Form.Item>
    </Form>
  );
};

export default DemoForm;
